module.exports = "/_next/static/images/02-be49dc17e6b4843fdbdfee5ed7482e26.png";